import { Transition } from "@headlessui/react";
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

export default function SmallDownloadButton(props) {
    const [showTooltip, setShowTooltip] = useState(false);
    const [tooltip, setTooltip] = useState("Download SVG");
    const tooltipOriginX = props.tooltipPosition === "bottom" ? 0 : 40;
    const tooltipOriginY = props.tooltipPosition === "bottom" ? 40 : 6;
    return (
        <>
            <button
                onClick={(e) => {
                    setShowTooltip(false);
                    props.onClick(e);
                }}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                type="button"
                className="items-center inline-flex w-full ring-0 outline-none justify-center rounded-md border border-gray-300 bg-white bg-opacity-90 px-2 py-2 font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none sm:col-start-1 sm:mt-0 text-xs dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700 dark:border-gray-700"
            >
                <span className="text-lg mr-1 sparkle w-3">
                <ArrowDownTrayIcon className="h-4 w-4" />
                </span>
            </button>
            <Transition.Root
                style={{
                    left: tooltipOriginX,
                    top: tooltipOriginY,
                }}
                className="hidden md:block absolute pointer-events-none top-8"
                show={showTooltip}
            >
                <Transition.Child
                    className={
                        "whitespace-nowrap backdrop-blur-sm bg-black bg-opacity-70 text-white font-medium text-xs rounded-lg px-4 p-1"
                    }
                    enter="transition-all ease-in-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transition-all ease-in-out duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    {tooltip}
                </Transition.Child>
            </Transition.Root>
        </>
    );
}
